import { Activity } from "PFTypes";

import css from "./content.module.scss";
import { PostContentBody } from "./post_content_body";

export type PostContentProps = {
  activity: Activity;
};

export const PostContent = ({ activity }: PostContentProps) => {
  const metadata = activity.metadata || {};
  const linkUrl = metadata?.og?.url;
  // We do render an "a" when a link is present and a "div" when is not
  const RenderTag = linkUrl ? "a" : "div";
  const linkProps = linkUrl ? { target: "_blank", rel: "noopener noreferrer", href: linkUrl } : {};

  return (
    <RenderTag className={css.wrapper} {...linkProps}>
      <div>
        <PostContentBody activity={activity} og={metadata.og} />
      </div>
    </RenderTag>
  );
};
